/**
 * constants/api.js — Single source of truth for API configuration.
 *
 * Usage:
 *   import { API_URL } from '../constants/api';
 *   fetch(`${API_URL}/api/posts`)
 *
 * Set REACT_APP_API_URL in your .env file for production.
 * Falls back to localhost:8001 for local development.
 */

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';
